import React, { useEffect, useState } from 'react';
import axiosInstance from '../../utils/axios';
import {
    Box,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Grid,
} from '@mui/material';
import { format } from 'date-fns';
import { DatePicker } from '@mui/x-date-pickers';

const OrderFilters = ({ filters, onFilterChange }) => {
    const [products, setProducts] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [couriers, setCouriers] = useState([]);

    useEffect(() => {
        // Получение справочников для фильтров (как в Addresses.js)
        axiosInstance.get('/products').then(res => {
            if (res.data && Array.isArray(res.data.data)) setProducts(res.data.data);
            else setProducts([]);
        }).catch(() => setProducts([]));
        axiosInstance.get('/cities').then(res => {
            if (res.data && Array.isArray(res.data.data)) setCities(res.data.data);
            else setCities([]);
        }).catch(() => setCities([]));
        axiosInstance.get('/districts').then(res => {
            if (res.data && Array.isArray(res.data.data)) setDistricts(res.data.data);
            else setDistricts([]);
        }).catch(() => setDistricts([]));
        axiosInstance.get('/staff').then(res => {
            if (res.data && Array.isArray(res.data.data)) {
                setCouriers(res.data.data.filter(staff => staff.role === 'courier'));
            } else setCouriers([]);
        }).catch(() => setCouriers([]));
    }, []);

    const handleChange = (field) => (event) => {
        let value = event?.target?.value ?? event;
        if (field === 'startDate' || field === 'endDate') {
            // Для дат передаем объект Date напрямую
            value = value;
        }
        onFilterChange({ ...filters, [field]: value });
    };

    return (
        <Box sx={{ mb: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5,
                    alignItems: 'center',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    p: 1.5,
                }}
            >
                <FormControl sx={{ minWidth: 120, flex: '1 1 120px' }} size="small">
                    <InputLabel>Город</InputLabel>
                    <Select
                        name="cityId"
                        value={filters.cityId || ''}
                        onChange={handleChange('cityId')}
                        label="Город"
                    >
                        <MenuItem value="">
                            <em>Все</em>
                        </MenuItem>
                        {cities.map(city => (
                            <MenuItem key={city._id} value={city._id}>{city.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl sx={{ minWidth: 120, flex: '1 1 120px' }} size="small">
                    <InputLabel>Район</InputLabel>
                    <Select
                        name="districtId"
                        value={filters.districtId || ''}
                        onChange={handleChange('districtId')}
                        label="Район"
                    >
                        <MenuItem value="">
                            <em>Все</em>
                        </MenuItem>
                        {districts.map(district => (
                            <MenuItem key={district._id} value={district._id}>{district.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl sx={{ minWidth: 120, flex: '1 1 120px' }} size="small">
                    <InputLabel>Тип</InputLabel>
                    <Select
                        name="type"
                        value={filters.type || ''}
                        onChange={handleChange('type')}
                        label="Тип"
                    >
                        <MenuItem value="">
                            <em>Все</em>
                        </MenuItem>
                        <MenuItem value="стелс">Стелс</MenuItem>
                        <MenuItem value="тайник">Тайник</MenuItem>
                        <MenuItem value="прикоп">Прикоп</MenuItem>
                        <MenuItem value="снежный прикоп">Снежный прикоп</MenuItem>
                        <MenuItem value="земляной прикоп">Земляной прикоп</MenuItem>
                         <MenuItem value="Прикоп-тайник">Прикоп-тайник</MenuItem>
                        
                        <MenuItem value="магнит">Магнит</MenuItem>
                    </Select>
                </FormControl>
                <FormControl sx={{ minWidth: 120, flex: '1 1 120px' }} size="small">
                    <InputLabel>Курьер</InputLabel>
                    <Select
                        name="courierId"
                        value={filters.courierId || ''}
                        onChange={handleChange('courierId')}
                        label="Курьер"
                    >
                        <MenuItem value="">
                            <em>Все</em>
                        </MenuItem>
                        {couriers.map(courier => (
                            <MenuItem key={courier._id} value={courier._id}>{courier.name} ({courier.username})</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    size="small"
                    placeholder="ID заказа"
                    value={filters.orderId || ''}
                    onChange={handleChange('orderId')}
                    sx={{ minWidth: 120, flex: '1 1 120px' }}
                />
                <TextField
                    size="small"
                    placeholder="User ID"
                    value={filters.userId || ''}
                    onChange={handleChange('userId')}
                    sx={{ minWidth: 120, flex: '1 1 120px' }}
                />
                <Select
                    size="small"
                    value={filters.status || ''}
                    displayEmpty
                    onChange={handleChange('status')}
                    sx={{ minWidth: 120, flex: '1 1 120px', bgcolor: 'background.paper' }}
                >
                    <MenuItem value="">Все статусы</MenuItem>
                    <MenuItem value="pending">Ожидает оплаты</MenuItem>
                    <MenuItem value="paid">Оплачен</MenuItem>
                    <MenuItem value="cancelled">Отменен</MenuItem>
                </Select>
                <FormControl sx={{ minWidth: 120, flex: '1 1 120px' }} size="small">
                    <InputLabel>Товар</InputLabel>
                    <Select
                        name="productId"
                        value={filters.productId || ''}
                        onChange={handleChange('productId')}
                        label="Товар"
                    >
                        <MenuItem value="">
                            <em>Все</em>
                        </MenuItem>
                        {products.map(product => (
                            <MenuItem key={product._id} value={product._id}>
                                {product.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    size="small"
                    placeholder="Фото"
                    value={filters.photo || ''}
                    onChange={handleChange('photo')}
                    sx={{ minWidth: 100, flex: '1 1 100px' }}
                />
                <DatePicker
                    value={filters.startDate}
                    onChange={handleChange('startDate')}
                    slotProps={{ textField: { size: 'small', placeholder: 'Дата с', sx: { minWidth: 120, flex: '1 1 120px', bgcolor: 'background.paper' } } }}
                />
                <DatePicker
                    value={filters.endDate}
                    onChange={handleChange('endDate')}
                    slotProps={{ textField: { size: 'small', placeholder: 'Дата по', sx: { minWidth: 120, flex: '1 1 120px', bgcolor: 'background.paper' } } }}
                />
            </Box>
        </Box>
    );
};

export default OrderFilters;
